import { getUsersAndGroups } from 'api/management'
import { useRouteLoaderData } from 'react-router-dom'

import { ROUTER_ID as GROUP_ROUTER_ID } from './GroupConfig.loader'

// todo: use router id everywhere
export const ROUTER_ID = 'usersConfig'

// 未ログインが上位に来るためのソート比較fn
// string can be '' or undefined
function compareDateString(a: string | undefined, b: string | undefined) {
  // aとbが空
  if (!a && !b) return 0
  // aが空
  if (!a) return -1
  // bが空
  if (!b) return 1
  // aとbの比較
  if (a === b) return 0
  return a > b ? -1 : 1
}

export default async function loader() {
  const dataApi = await getUsersAndGroups()
  // dataApi is cached: don't edit that
  const data = JSON.parse(JSON.stringify(dataApi)) as Awaited<
    ReturnType<typeof getUsersAndGroups>
  >
  data.users = data.users.sort((a, b) =>
    compareDateString(a.updatedAt, b.updatedAt),
  )
  // TODO: []??
  data.subGroups =
    data.subGroups?.sort((a, b) =>
      compareDateString(a.createdAt, b.createdAt),
    ) || []
  return data
}

export function useLoaderData() {
  return useLoaderDataInternal(ROUTER_ID)
}

export function useLoaderDataInternal(
  id: typeof ROUTER_ID | typeof GROUP_ROUTER_ID,
) {
  const data = useRouteLoaderData(id) as Awaited<ReturnType<typeof loader>> & {
    subGroupNames: string[]
  }
  data.subGroupNames = data.subGroups.map((x) => x.name)
  return data
}
